import {
  scrollIntoView
} from "./chunk.XS4D3FDG.js";
import {
  dropdown_styles_default
} from "./chunk.KROSL4UM.js";
import {
  menuItemSelectors
} from "./chunk.QHZ3R2SE.js";
import {
  createPopper
} from "./chunk.A364I6JA.js";
import {
  animateTo,
  stopAnimations
} from "./chunk.JEYCYKK2.js";
import {
  emit,
  waitForEvent
} from "./chunk.C4ZTYQN4.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  getAnimation,
  setDefaultAnimation
} from "./chunk.456HIP2G.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// node_modules/@shoelace-style/shoelace/dist/internal/tabbable.js
function isTabbable(el) {
  const tag = el.tagName.toLowerCase();
  if (el.getAttribute("tabindex") === "-1") {
    return false;
  }
  if (el.hasAttribute("disabled")) {
    return false;
  }
  if (el.hasAttribute("aria-disabled") && el.getAttribute("aria-disabled") !== "false") {
    return false;
  }
  if (tag === "input" && el.getAttribute("type") === "radio" && !el.hasAttribute("checked")) {
    return false;
  }
  if (el.offsetParent === null) {
    return false;
  }
  if (window.getComputedStyle(el).visibility === "hidden") {
    return false;
  }
  if ((tag === "audio" || tag === "video") && el.hasAttribute("controls")) {
    return true;
  }
  if (el.hasAttribute("tabindex")) {
    return true;
  }
  if (el.hasAttribute("contenteditable") && el.getAttribute("contenteditable") !== "false") {
    return true;
  }
  return ["button", "input", "select", "textarea", "a", "audio", "video", "summary"].includes(tag);
}
function getTabbableBoundary(root) {
  var _a, _b;
  const allElements = [];
  function walk(el) {
    if (el instanceof HTMLElement) {
      allElements.push(el);
      if (el.shadowRoot !== null && el.shadowRoot.mode === "open") {
        walk(el.shadowRoot);
      }
    }
    [...el.querySelectorAll("*")].forEach((e2) => walk(e2));
  }
  walk(root);
  const start = (_a = allElements.find((el) => isTabbable(el))) !== null && _a !== void 0 ? _a : null;
  const end = (_b = allElements.reverse().find((el) => isTabbable(el))) !== null && _b !== void 0 ? _b : null;
  return { start, end };
}

// src/components/dropdown/dropdown.ts
var FadvDropdown = class extends s {
  constructor() {
    super(...arguments);
    this.open = false;
    this.placement = "bottom-start";
    this.disabled = false;
    this.stayOpenOnSelect = false;
    this.distance = 0;
    this.skidding = 0;
    this.hoist = false;
    this.block = false;
    this.previousTabTagName = "";
  }
  connectedCallback() {
    super.connectedCallback();
    this.handleMenuItemActivate = this.handleMenuItemActivate.bind(this);
    this.handlePanelSelect = this.handlePanelSelect.bind(this);
    this.handleDocumentKeyDown = this.handleDocumentKeyDown.bind(this);
    this.handleDocumentMouseDown = this.handleDocumentMouseDown.bind(this);
    if (!this.containingElement) {
      this.containingElement = this;
    }
    this.updateComplete.then(() => {
      this.popoverInstance = createPopper(this.trigger, this.positioner, {
        placement: this.placement,
        strategy: this.hoist ? "fixed" : "absolute",
        modifiers: [
          {
            name: "flip",
            options: {
              boundary: "viewport"
            }
          },
          {
            name: "offset",
            options: {
              offset: [this.skidding, this.distance]
            }
          }
        ]
      });
    });
  }
  async firstUpdated() {
    this.panel.hidden = !this.open;
    if (this.open) {
      this.addOpenListeners();
      await this.updateComplete;
    }
    this.handleBlockChange();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeOpenListeners();
    this.hide();
  }
  focusOnTrigger() {
    const slot = this.trigger.querySelector("slot");
    const trigger = slot.assignedElements({ flatten: true })[0];
    if (typeof (trigger == null ? void 0 : trigger.focus) === "function") {
      trigger.focus();
    }
  }
  getMenu() {
    var _a;
    const slotted = ((_a = this.panel.querySelector("slot")) == null ? void 0 : _a.assignedElements({ flatten: true })) || [];
    return slotted.find((el) => hasTag(el, "fadv-menu"));
  }
  handleBlockChange() {
    const button = [...this.children].find((x) => hasTag(x, "fadv-button"));
    if (button) {
      button.block = this.block;
    }
  }
  handleDocumentKeyDown(event) {
    if (event.key === "Escape") {
      this.hide();
      this.focusOnTrigger();
      return;
    }
    if (event.key === "Tab") {
      this.handleTabKey(event);
    }
  }
  handleTabKey(event) {
    var _a;
    if (this.open && menuItemSelectors.includes(((_a = document.activeElement) == null ? void 0 : _a.tagName.toLowerCase()) || "")) {
      event.preventDefault();
      this.hide();
      this.focusOnTrigger();
      return;
    }
    setTimeout(() => {
      var _a2, _b, _c;
      const activeElement = ((_a2 = this.containingElement) == null ? void 0 : _a2.getRootNode()) instanceof ShadowRoot ? (_c = (_b = document.activeElement) == null ? void 0 : _b.shadowRoot) == null ? void 0 : _c.activeElement : document.activeElement;
      const currentElement = event.target.tagName.toLowerCase();
      if (this.previousTabTagName === "fadv-menu" && currentElement === "fadv-menu") {
        this.hide();
      }
      this.previousTabTagName = currentElement;
      if (["fadv-filter", "fadv-menu"].includes(currentElement)) {
        return;
      }
      if (currentElement === "fadv-search") {
        const menu = this.getMenu();
        if (!menu)
          return;
        const items = menu.getAllItems({ includeDisabled: false, includeHidden: false });
        const firstChecked = items.find((i2) => i2.checked);
        const firstItem = firstChecked || items[0];
        menu.setCurrentItem(firstItem);
        firstItem.focus();
        return;
      }
      if (!this.containingElement || (activeElement == null ? void 0 : activeElement.closest(this.containingElement.tagName.toLowerCase())) !== this.containingElement) {
        this.hide();
      }
    });
  }
  handleDocumentMouseDown(event) {
    const path = event.composedPath();
    if (this.containingElement && !path.includes(this.containingElement)) {
      this.hide();
    }
  }
  handleMenuItemActivate(event) {
    const item = event.target;
    scrollIntoView(item, this.panel);
  }
  handlePanelSelect(event) {
    const target = event.target;
    if (!this.stayOpenOnSelect && hasTag(target, "fadv-menu")) {
      this.hide();
      this.focusOnTrigger();
    }
  }
  handlePopoverOptionsChange() {
    var _a;
    (_a = this.popoverInstance) == null ? void 0 : _a.setOptions({
      placement: this.placement,
      strategy: this.hoist ? "fixed" : "absolute",
      modifiers: [
        {
          name: "flip",
          options: {
            boundary: "viewport"
          }
        },
        {
          name: "offset",
          options: {
            offset: [this.skidding, this.distance]
          }
        }
      ]
    });
  }
  getMenuItems(menu) {
    const fadvMenu = this.getMenu();
    if (!(fadvMenu == null ? void 0 : fadvMenu.getAllItems) || typeof menu.getAllItems !== "function")
      return [];
    return fadvMenu == null ? void 0 : fadvMenu.getAllItems({ includeDisabled: false, includeHidden: false });
  }
  handleTriggerClick() {
    if (this.open) {
      this.hide();
    } else {
      this.show();
    }
  }
  handleTriggerKeyDown(event) {
    if (event.key === "Escape") {
      this.focusOnTrigger();
      this.hide();
      return;
    }
    if (["", "Enter"].includes(event.key)) {
      event.preventDefault();
      this.handleTriggerClick();
      return;
    }
    const menu = this.getMenu();
    if (menu) {
      const menuItems = this.getMenuItems(menu);
      const firstMenuItem = menuItems[0];
      const lastMenuItem = menuItems[menuItems.length - 1];
      if (["ArrowDown", "ArrowUp"].includes(event.key)) {
        event.preventDefault();
        if (!this.open) {
          this.show();
        }
        if (menuItems.length > 0) {
          requestAnimationFrame(() => {
            if (event.key === "ArrowDown" && firstMenuItem) {
              menu.setCurrentItem(firstMenuItem);
              firstMenuItem.focus();
            }
            if (event.key === "ArrowUp" && lastMenuItem) {
              menu.setCurrentItem(lastMenuItem);
              lastMenuItem.focus();
            }
          });
        }
      }
      const ignoredKeys = ["Tab", "Shift", "Meta", "Ctrl", "Alt"];
      if (this.open && !ignoredKeys.includes(event.key)) {
        menu.typeToSelect(event);
      }
    }
  }
  handleTriggerKeyUp(event) {
    if (event.key === " ") {
      event.preventDefault();
    }
  }
  handleTriggerSlotChange() {
    this.updateAccessibleTrigger();
  }
  updateAccessibleTrigger() {
    const slot = this.trigger.querySelector("slot");
    const assignedElements = slot.assignedElements({ flatten: true });
    const accessibleTrigger = assignedElements.find((el) => getTabbableBoundary(el).start);
    let target;
    if (accessibleTrigger) {
      switch (accessibleTrigger.tagName.toLowerCase()) {
        case "sl-button":
        case "sl-icon-button":
          target = accessibleTrigger.button;
          break;
        default:
          target = accessibleTrigger;
      }
      target.setAttribute("aria-haspopup", "true");
      target.setAttribute("aria-expanded", this.open ? "true" : "false");
    }
  }
  async show() {
    if (this.open) {
      return;
    }
    this.open = true;
    await waitForEvent(this, "sl-after-show");
  }
  async hide() {
    if (!this.open) {
      return;
    }
    const menu = this.getMenu();
    if (menu) {
      const menuItems = this.getMenuItems(menu);
      menuItems.forEach((i2) => i2.removeAttribute("tabindex"));
    }
    this.open = false;
    this.previousTabTagName = "";
    await waitForEvent(this, "sl-after-hide");
  }
  handleDefaultSlotChange() {
    const menu = this.getMenu();
    if (!menu)
      return;
    const menuItems = this.getMenuItems(menu);
    for (const item of menuItems) {
      item.classList.add("dropdown--menu-item");
    }
  }
  reposition() {
    var _a;
    if (!this.open) {
      return;
    }
    (_a = this.popoverInstance) == null ? void 0 : _a.update();
  }
  addOpenListeners() {
    this.panel.addEventListener("sl-activate", this.handleMenuItemActivate);
    this.panel.addEventListener("sl-select", this.handlePanelSelect);
    document.addEventListener("keydown", this.handleDocumentKeyDown);
    document.addEventListener("mousedown", this.handleDocumentMouseDown);
  }
  removeOpenListeners() {
    this.panel.removeEventListener("sl-activate", this.handleMenuItemActivate);
    this.panel.removeEventListener("sl-select", this.handlePanelSelect);
    document.removeEventListener("keydown", this.handleDocumentKeyDown);
    document.removeEventListener("mousedown", this.handleDocumentMouseDown);
  }
  async handleOpenChange() {
    var _a;
    if (this.disabled) {
      this.open = false;
      return;
    }
    this.updateAccessibleTrigger();
    if (this.open) {
      emit(this, "sl-show");
      this.addOpenListeners();
      await stopAnimations(this);
      (_a = this.popoverInstance) == null ? void 0 : _a.update();
      this.panel.hidden = false;
      const { keyframes, options } = getAnimation(this, "dropdown.show");
      await animateTo(this.panel, keyframes, options);
      emit(this, "sl-after-show");
    } else {
      emit(this, "sl-hide");
      this.removeOpenListeners();
      await stopAnimations(this);
      const { keyframes, options } = getAnimation(this, "dropdown.hide");
      await animateTo(this.panel, keyframes, options);
      this.panel.hidden = true;
      emit(this, "sl-after-hide");
    }
  }
  render() {
    return $`<div part="base" id="dropdown" class=${o({
      dropdown: true,
      "dropdown--open": this.open,
      "dropdown--small": this.size === "small",
      "dropdown--large": this.size === "large"
    })} ><span part="trigger" class="dropdown__trigger" @click=${this.handleTriggerClick} @keydown=${this.handleTriggerKeyDown} @keyup=${this.handleTriggerKeyUp} ><slot name="trigger" @slotchange=${this.handleTriggerSlotChange}></slot></span><div class="dropdown__positioner"><div part="panel" @slotchange=${this.handleDefaultSlotChange} class="dropdown__panel" aria-hidden=${this.open ? "false" : "true"} aria-describedby="dropdown" ><slot></slot></div></div></div>`;
  }
};
FadvDropdown.styles = dropdown_styles_default;
__decorateClass([
  i(".dropdown__trigger")
], FadvDropdown.prototype, "trigger", 2);
__decorateClass([
  i(".dropdown__panel")
], FadvDropdown.prototype, "panel", 2);
__decorateClass([
  i(".dropdown__positioner")
], FadvDropdown.prototype, "positioner", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvDropdown.prototype, "open", 2);
__decorateClass([
  e({ reflect: true })
], FadvDropdown.prototype, "placement", 2);
__decorateClass([
  e({ type: Boolean })
], FadvDropdown.prototype, "disabled", 2);
__decorateClass([
  e({ attribute: "stay-open-on-select", type: Boolean, reflect: true })
], FadvDropdown.prototype, "stayOpenOnSelect", 2);
__decorateClass([
  e({ attribute: false })
], FadvDropdown.prototype, "containingElement", 2);
__decorateClass([
  e({ type: Number })
], FadvDropdown.prototype, "distance", 2);
__decorateClass([
  e({ type: Number })
], FadvDropdown.prototype, "skidding", 2);
__decorateClass([
  e({ type: Boolean })
], FadvDropdown.prototype, "hoist", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvDropdown.prototype, "block", 2);
__decorateClass([
  e()
], FadvDropdown.prototype, "size", 2);
__decorateClass([
  t()
], FadvDropdown.prototype, "previousTabTagName", 2);
__decorateClass([
  watch("block")
], FadvDropdown.prototype, "handleBlockChange", 1);
__decorateClass([
  watch("distance"),
  watch("hoist"),
  watch("placement"),
  watch("skidding")
], FadvDropdown.prototype, "handlePopoverOptionsChange", 1);
__decorateClass([
  watch("open", { waitUntilFirstUpdate: true })
], FadvDropdown.prototype, "handleOpenChange", 1);
FadvDropdown = __decorateClass([
  n("fadv-dropdown")
], FadvDropdown);
setDefaultAnimation("dropdown.show", {
  keyframes: [
    { opacity: 0, transform: "scale(0.9)" },
    { opacity: 1, transform: "scale(1)" }
  ],
  options: { duration: 100, easing: "ease" }
});
setDefaultAnimation("dropdown.hide", {
  keyframes: [
    { opacity: 1, transform: "scale(1)" },
    { opacity: 0, transform: "scale(0.9)" }
  ],
  options: { duration: 100, easing: "ease" }
});

export {
  FadvDropdown
};
